

<div style="display:flex;flex-direction:column;height:100%;box-sizing:border-box;">

<div style="display:block;text-align:right;margin-top:10px;margin-right:10px;">
    <img src="../../../../assets/images/SPACE AR small.png" style="height:30px;width:100px;"/>
</div>

<img src="../../../../assets/icons/yellow-warning-triangle.png" style="height:45px;width:45px;margin-left:10px;position:relative;top:-30px;">

<div style="margin-left:30px;margin-top:20px;">
    <span style="font-size:18px;font-weight: bold;;">{{data.title}}</span>
</div>

<div style="margin-left:70px;margin-top:20px;">
    <span>{{data.line1}}</span>
</div>

@if(data.line2 != ''){
    <div  style="margin-left:70px;margin-top:10px;">
    <span>{{data.line2}}</span>
    </div>
}

<div mat-dialog-actions style="display:block;text-align: right;margin-right:10px;margin-top:auto;margin-bottom:10px;">
  <button mat-button [mat-dialog-close]="false" >Cancel</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>{{data.submitButton}}</button>
</div>

</div>

